import { takeLatest, put } from 'redux-saga/effects';

import { Actions as BlogGetAllActions } from 'app/redux/blog/get-all/actions';
import { Actions as MediaGetAllActions } from 'app/redux/media/get-all/actions';
import { Types } from './actions';

const initialize = function*() {
  yield put(BlogGetAllActions.request());
  yield put(MediaGetAllActions.request());
};

const BlogSaga = function*() {
  yield takeLatest(Types.INITIALIZE, initialize);
};

export default BlogSaga;



// WEBPACK FOOTER //
// ./src/redux/ui/blog/sagas.js